import { apiCall } from "../helpers/api";

export const notifications = (params = {}) => dispatch => {
    params.path = params.path || "notifications";
    return dispatch(apiCall(params));
}